__turbopack_context__.v({
  "browser": "ExampleBlock-module-scss-module__3QqrJq__browser",
  "button": "ExampleBlock-module-scss-module__3QqrJq__button",
  "container": "ExampleBlock-module-scss-module__3QqrJq__container",
  "darkColors": "ExampleBlock-module-scss-module__3QqrJq__darkColors",
  "expanded": "ExampleBlock-module-scss-module__3QqrJq__expanded",
  "green": "ExampleBlock-module-scss-module__3QqrJq__green",
  "header": "ExampleBlock-module-scss-module__3QqrJq__header",
  "image": "ExampleBlock-module-scss-module__3QqrJq__image",
  "logo": "ExampleBlock-module-scss-module__3QqrJq__logo",
  "overlay": "ExampleBlock-module-scss-module__3QqrJq__overlay",
  "pink": "ExampleBlock-module-scss-module__3QqrJq__pink",
  "purple": "ExampleBlock-module-scss-module__3QqrJq__purple",
  "title": "ExampleBlock-module-scss-module__3QqrJq__title",
  "yellow": "ExampleBlock-module-scss-module__3QqrJq__yellow",
});
